import React, { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import frLocale from '@fullcalendar/core/locales/fr';
import { useNavigate } from 'react-router-dom';
import { getAuthServerBase } from '../utils/runtime';

const AUTH_SERVER = getAuthServerBase();

function ProfessionalAgenda() {
  const [events, setEvents] = useState([]);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${AUTH_SERVER}/me`, { credentials: 'include' })
      .then(res => res.json())
      .then(data => setUser(data.user || data))
      .catch(() => {
        alert('Non connecté');
        navigate('/');
      });
  }, [navigate]);

  useEffect(() => {
    if (!user?.email) return;

    const fetchData = async () => {
      try {
        const userRes = await fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/users/email/${user.email}`);
        const userData = await userRes.json();
        const id = userData.user_id;

        const [availRes, servRes] = await Promise.all([
          fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${id}/weekly-availabilities`),
          fetch(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${id}/services`)
        ]);

        const [availabilities, services] = await Promise.all([
          availRes.json(),
          servRes.json()
        ]);

        const today = new Date();
        const monday = new Date(today.setDate(today.getDate() - today.getDay() + 1));

        const eventsFormatted = availabilities.map((a) => {
          const service = services.find(s => s.service_id === a.service_id);
          const dayOffset = (a.day_of_week + 6) % 7;
          const start = new Date(monday);
          start.setDate(start.getDate() + dayOffset);
          const [h, m] = a.start_time.split(':');
          start.setHours(h, m);

          const end = new Date(start);
          if (a.end_time) {
            const [eh, em] = a.end_time.split(':');
            end.setHours(eh, em);
          } else {
            end.setHours(start.getHours() + 1);
          }

          return {
            title: service?.name || 'Service inconnu',
            start,
            end,
            allDay: false,
          };
        });

        setEvents(eventsFormatted);
      } catch (err) {
        console.error('❌ Erreur chargement agenda:', err);
      }
    };

    fetchData();
  }, [user]);

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Agenda hebdomadaire</h2>
      <FullCalendar
        plugins={[timeGridPlugin]}
        initialView="timeGridWeek"
        slotMinTime="08:00:00"
        slotMaxTime="20:00:00"
        locale={frLocale}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'timeGridWeek,timeGridDay'
        }}
        events={events}
        height="auto"
      />
    </div>
  );
}

export default ProfessionalAgenda;
